import url from "./url";
// import vueHelper from "./vueHelper";

let hasConsole = true; //typeof console === 'object';
let $types = [
  "Boolean",
  "Number",
  "String",
  "Function",
  "Array",
  "Date",
  "RegExp",
  "Object",
  "Error",
  "Symbol",
  "Promise"
];
let class2type = {};
let canvas = null;
let $files = [
  {
    absolutePath: "",
    contentType: "",
    id: "",
    name: "",
    originalFileName: "",
    relativePath: "",
    size: 0,
    suffix: "",
    uploadDate: ""
  }
];
let sessionTimeoutConfirmOpen = false;
let topWindow = null;
let designEl = null;
let isMobile = null;
const getProto = Object.getPrototypeOf;
const hasOwn = class2type.hasOwnProperty;
const fnToString = hasOwn.toString;
const ObjectFunctionString = fnToString.call(Object);
const toString = class2type.toString;
const _console = window.console;
const oldError = _console.error;

const uuidCharts = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");

const hasOwnProperty = Object.prototype.hasOwnProperty;

const sessionTimoutHandler = function () {
  if (!sessionTimeoutConfirmOpen) {
    sessionTimeoutConfirmOpen = true;
    if (dsf.client.mobile()) {
      dsf.layer.closeLoading(document.querySelector(".van-toast--loading")?.__vue__?.$parent);
    }
    dsf.layer
      .alert(dsf.config.setting_public_token_invalid)
      .then(() => {
        let topWin = dsf.getTopWindow();
        let root = topWin.__multiPageVm__ ? topWin : window;
        dsf.loginOut();
      })
      .catch(() => {})
      .finally(() => {
        sessionTimeoutConfirmOpen = false;
      });
  }
};

const isNative = function (Ctor) {
  return typeof Ctor === "function" && /native code/.test(Ctor.toString());
};

const hasSymbol =
  typeof Symbol !== "undefined" &&
  isNative(Symbol) &&
  typeof Reflect !== "undefined" &&
  isNative(Reflect.ownKeys);

window.consoleOn = () => {
  hasConsole = true;
};

$types.forEach((elem) => {
  class2type["[object " + elem + "]"] = elem.toLowerCase();
});

export default {
  version: "5.0",
  // vueHelper,
  //是否是dsf5.0版
  isDsf5(dsf) {
    let version = "5.0";
    if (!dsf) {
      return false;
    }
    if (typeof dsf == "object") {
      version = dsf?.version || "";
    } else if (typeof dsf == "string") {
      version = dsf || "";
    }
    let v = version.split ? version.split(".") : [];
    return v[0] == "5";
  },
  getVueAppRoot(elId = "app") {
    let app = document.querySelector("#" + elId);
    let appVue = app?.__vue__?.$root;
    return appVue;
  },
  //预加载get请求接口数据
  preloadFetch(url, params, base) {
    let urlParams = "";
    if (!dsf.isEmptyObject(params)) {
      urlParams = dsf.url.queryStringStringify(params);
      if (urlParams) {
        url += url.indexOf("?") > 0 ? "&" + urlParams : "?" + urlParams;
      }
    }
    let sameLinks = document.querySelectorAll("[href='" + url + "']");
    if (sameLinks.length > 0) {
      for (let i = sameLinks.length - 1; i >= 0; i--) {
        let it = sameLinks[i];
        it.parentNode.removeChild(it);
      }
    }
    let link = document.createElement("link");
    link.rel = "preload";
    link.as = "fetch";
    link.href = dsf.url.getWebPath(url, base);
    link.crossOrigin = "";
    document.head.appendChild(link);
    return link;
  },
  //预加载script文件内容
  preloadScript(url, linkId) {
    let link = document.createElement("link");
    link.href = url;
    link.rel = "preload";
    link.as = "script";
    link.id = linkId || url;
    document.head.appendChild(link);
    return link;
  },
  preloadCss(url, linkId) {
    let link = document.createElement("link");
    link.href = url;
    link.rel = "preload";
    link.as = "style";
    link.id = linkId || url;
    document.head.appendChild(link);
    return link;
  },
  //获取es6模块
  getEsModule(module) {
    if (module.__esModule || (hasSymbol && module[Symbol.toStringTag] === "Module")) {
      module = module?.default || module;
    }
    return module;
  },
  noop: function () {},
  noopPromise: toPromise,
  //获取唯一标识
  uuid: function (len, radix) {
    var chars = uuidCharts,
      uuid = [],
      i;
    radix = radix || chars.length;
    len = len || 16;
    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
      // rfc4122, version 4 form
      var r;

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "";
      uuid[14] = "4";

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16);
          uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
        }
      }
    }

    return uuid.join("");
  },
  //验证是否不为undefind或者null
  isDef: function (obj) {
    return obj !== undefined && obj != null;
  },
  //验证是否为undefind或者null
  isUnDef: function (obj) {
    return obj === undefined || obj === null;
  },
  //比对版本号
  compareVersion(v1, v2, chart = ".") {
    v1 = v1.split(chart);
    v2 = v2.split(chart);
    const len = Math.max(v1.length, v2.length);
    while (v1.length < len) {
      v1.push("0");
    }
    while (v2.length < len) {
      v2.push("0");
    }
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i]);
      const num2 = parseInt(v2[i]);
      if (num1 > num2) {
        return 1;
      } else if (num1 < num2) {
        return -1;
      }
    }
    return 0;
  },
  //获取对象类型
  type: function (obj) {
    if (obj == null) {
      return obj + "";
    }
    // Support: Android <=2.3 only (functionish RegExp)
    return typeof obj === "object" || typeof obj === "function"
      ? class2type[toString.call(obj)] || "object"
      : typeof obj;
  },
  hasOwn: function (obj, key) {
    return hasOwnProperty.call(obj, key);
  },
  hasSymbol,
  //是否原生支持的方法
  isNative,
  //是否多页应用
  isMultiPage() {
    let multiPagePath = dsf.config.setting_public_multipagename;
    if (window.location.pathname.indexOf(multiPagePath) > 0) {
      return true;
    }
    return false;
  },
  //获取dsf5.0支持的最顶级窗口
  getTopWindow: function () {
    if (topWindow) {
      return topWindow;
    }
    let self = window.self;
    let current = self;
    while (current?.parent != current) {
      try {
        let isCrossDomain = false;
        let currUrl = "",
          parentUrl = "";
        try {
          currUrl = url.parse(current.location.href);
          parentUrl = url.parse(current.parent.location.href);
          if (currUrl.host != parentUrl.host) {
            isCrossDomain = true;
          }
        } catch (ex) {
          this.error(ex);
          isCrossDomain = true;
        }
        if (!isCrossDomain && current.parent && current.parent?.dsf?.version == "5.0") {
          current = current.parent;
        } else {
          break;
        }
      } catch (ex) {
        this.error(ex);
      }
    }
    topWindow = current;
    return current;
  },
  kebabCase: function (str, joinChar) {
    let hyphenateRE = /\B([A-Z])/g;
    return str.replace(hyphenateRE, joinChar + "$1").toLowerCase();
  },
  camelCase: function (str, joinChar, firstChatUpperCase) {
    var camelizeRE = new RegExp("\\" + joinChar + "(\\w)", "g");
    str = str.replace(camelizeRE, function (_, c) {
      return c ? c.toUpperCase() : "";
    });
    if (firstChatUpperCase) {
      str = str.substr(0, 1).toUpperCase() + str.substr(1);
    }
    return str;
  },
  //半角转换为全角
  toDBC(str) {
    let result = "";
    for (var i = 0; i < str.length; i++) {
      let code = str.charCodeAt(i);
      if (code >= 33 && code <= 126) {
        result += String.fromCharCode(str.charCodeAt(i) + 65248);
      } else if (code == 32) {
        result += String.fromCharCode(str.charCodeAt(i) + 12288 - 32);
      } else {
        result += str.charAt(i);
      }
    }
    return result;
  },
  //全角转换为半角
  toCDB(str) {
    let result = "";
    for (let i = 0; i < str.length; i++) {
      let code = str.charCodeAt(i);
      if (code >= 65281 && code <= 65374) {
        result += String.fromCharCode(str.charCodeAt(i) - 65248);
      } else if (code == 12288) {
        result += String.fromCharCode(str.charCodeAt(i) - 12288 + 32);
      } else {
        result += str.charAt(i);
      }
    }
    return result;
  },
  isElementEditable(elm) {
    elm = $(elm);
    if (elm.get(0).tagName == "INPUT") {
      if (
        (elm.attr("type") == "text" || elm.attr("type") == "password") &&
        !elm.prop("readonly") &&
        !elm.prop("disabled")
      ) {
        return true;
      }
    } else if (elm.get(0).tagName == "TEXTAREA") {
      if (!elm.prop("readonly") && !elm.prop("disabled")) {
        return true;
      }
    } else if (elm.prop("contenteditable") && elm.prop("contenteditable") === "true") {
      return true;
    } else {
      //如果元素在可编辑元素内
      let c = elm.closest("[contenteditable=true]");
      if (c.length > 0) {
        return true;
      }
    }
    return false;
  },
  pxToRem(size) {
    if (dsf.isUnDef(designEl)) {
      designEl = document.querySelector(".ds-designer");
    }
    if (dsf.isUnDef(isMobile)) {
      isMobile =
        document.querySelector(".mobile-app") || (designEl ? designEl.matches(".mobile") : false);
    }
    if (this.type(size) == "string") {
      if (this.isNumber(size)) {
        return parseFloat(size) / 50 + "rem";
      } else if (size.endsWith("px")) {
        return parseFloat(size) / 50 + "rem";
      } else if (size.endsWith("vw")) {
        if (designEl && isMobile) {
          return (375 * (parseFloat(size) / 100)) / 50 + "rem";
        } else {
          return size;
        }
      } else if (size.endsWith("vh")) {
        if (designEl && isMobile) {
          return (667 * (parseFloat(size) / 100)) / 50 + "rem";
        } else {
          return size;
        }
      } else {
        return size;
      }
    } else if (this.type(size) == "number") {
      return size / 50 + "rem";
    } else {
      return size;
    }
  },
  px(v) {
    if (this.isNumber(v)) {
      return v + "px";
    } else {
      return v;
    }
  },
  unitSize(v, unit = "px") {
    if (dsf.isArray(v)) {
      return _.map(v, (it) => {
        return dsf.unitSize(it, unit);
      });
    } else {
      if (unit == "px") {
        return dsf.px(v);
      } else if (unit == "rem") {
        return dsf.pxToRem(v);
      }
    }
  },
  escapeFilter(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  },
  wordUnitToPx: function (val) {
    if (!/(pt|cm)/.test(val)) {
      return val;
    }
    var unit;
    val.replace(/([\d.]+)(\w+)/, function (str, v, u) {
      val = v;
      unit = u;
    });
    switch (unit) {
    case "cm":
      val = parseFloat(val) * 25;
      break;
    case "pt":
      val = Math.round((parseFloat(val) * 96) / 72);
    }
    return val + (val ? "px" : "");
  },
  unescapeHTML(html) {
    return String(html)
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&");
  },
  //深度对比两个对象是否相同b
  isEqualObject(a, b) {
    var _this = this;
    if (a === b) {
      return true;
    }
    var isObjectA = a ? typeof a == "object" : false;
    var isObjectB = b ? typeof b == "object" : false;
    if (isObjectA && isObjectB) {
      try {
        var isArrayA = _this.type(a) == "array";
        var isArrayB = _this.type(b) == "array";
        if (isArrayA && isArrayB) {
          return (
            a.length === b.length &&
            a.every(function (e, i) {
              return _this.isEqualObject(e, b[i]);
            })
          );
        } else if (a instanceof Date && b instanceof Date) {
          return a.getTime() === b.getTime();
        } else if (!isArrayA && !isArrayB) {
          var keysA = Object.keys(a);
          var keysB = Object.keys(b);
          return (
            keysA.length === keysB.length &&
            keysA.every(function (key) {
              return _this.isEqualObject(a[key], b[key]);
            })
          );
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b);
    } else {
      return false;
    }
  },
  //验证是否为一个空对象
  isEmptyObject: _.isEmpty,
  //验证是否是个数字
  isNumber: function (val) {
    if (this.isUnDef(val) || val === "") {
      return false;
    } else {
      if (dsf.type(val) == "boolean") {
        return false;
      } else if (val instanceof Date) {
        return false;
      }
      return !isNaN(val);
    }
  },
  //验证是否是一个纯粹的对象
  isPlainObject: function (obj) {
    var proto, Ctor;
    if (!obj || toString.call(obj) !== "[object Object]") {
      return false;
    }

    proto = getProto(obj);
    if (!proto) {
      return true;
    }
    Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
    return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
  },
  //验证类型是否为函数
  isFunction(val) {
    return this.type(val) == "function";
  },
  isArray(val) {
    return Array.isArray ? Array.isArray(val) : this.type(val) == "array";
  },
  isPromise(val) {
    return this.type(val) == "promise";
  },
  isObject(val) {
    return this.type(val) == "object";
  },
  isString(val) {
    return this.type(val) == "string";
  },
  isBoolean(val) {
    return this.type(val) == "boolean";
  },
  isDate(val) {
    return this.type(val) == "date";
  },
  isError(val) {
    return this.type(val) == "error";
  },
  //关闭页面上所有的popover
  closeAllPopover() {
    let popoverElms = document.querySelectorAll(".el-popper");
    for (let i = 0; i < popoverElms.length; i++) {
      let popoverElm = popoverElms[i];
      let popover = popoverElm.__vue__;
      if (popoverElm.matches(".el-select-dropdown")) {
        //下拉框
        if (popover.$parent) {
          popover.$parent.visible = false;
        }
      } else {
        //普通popover
        if (popover?.$parent?.doClose) {
          popover?.$parent?.doClose?.();
        }
      }
    }
  },
  //http错误统一处理
  httpError(error, opts) {
    opts = this.isDef(opts) ? opts : {};
    let isSilent = this.isDef(opts.isSilent) ? opts.isSilent : false;
    const SESSION_TIMEOUT = "sessionTimeout";
    let errorMessage = "";
    if (this.isString(error)) {
      errorMessage = error;
    } else if (this.isObject(error) && error.message) {
      errorMessage = error.message;
    } else if (this.isError(error)) {
      errorMessage = error.message;
    } else if (opts && opts.message) {
      errorMessage = opts.message;
    }
    if (errorMessage == SESSION_TIMEOUT) {
      sessionTimoutHandler();
      this.error(error);
    } else {
      !isSilent && this.layer.message(errorMessage, false);
      this.error(error);
      opts.callback && opts.callback(error);
    }
  },
  //处理平台的文件url格式
  getFilePath(str, isAbsolute, index) {
    index = this.isDef(index) ? index : 0;
    let files = null;
    if (str && this.type(str) == "string") {
      try {
        let result = JSON.parse(str);
        if (this.type(result) == "array") {
          files = result;
        } else if (this.type(result) == "object") {
          files = [result];
        }
      } catch (ex) {
        return str;
      }
    } else {
      return "";
    }
    if (isAbsolute) {
      return files[index].absolutePath;
    } else {
      return dsf.url.getWebPath(files[index].relativePath);
    }
  },
  getFileInfo(str, index) {
    let files = [];
    if (str) {
      let result = JSON.parse(str);
      if (this.type(result) == "array") {
        files = result;
      } else if (this.type(result) == "object") {
        files = [result];
      }
    }
    if (this.isDef(index)) {
      return files[index];
    }
    return files;
  },
  debugLog: function () {
    debugConsoleProxy("log", arguments);
  },
  debugTime: function () {
    debugConsoleProxy("time", arguments);
  },
  //代理console.timeEnd
  debugTimeEnd: function () {
    debugConsoleProxy("timeEnd", arguments);
  },
  //代理console.warn
  debugWarn: function () {
    debugConsoleProxy("warn", arguments);
  },
  //代理console.log
  log: function () {
    consoleProxy("log", arguments);
  },
  //代理console.time
  time: function () {
    consoleProxy("time", arguments);
  },
  //代理console.timeEnd
  timeEnd: function () {
    consoleProxy("timeEnd", arguments);
  },
  //代理console.warn
  warn: function () {
    consoleProxy("warn", arguments);
  },
  globalErrorHandler(...args) {},
  //代理console.error
  error: function () {
    if (hasConsole) {
      var method = _console.error || _console.log;
      Function.apply.call(method, _console, arguments);
    }
  },
  mergeConfig: function () {
    let args = Array.prototype.slice.call(arguments, 0);
    let callback = (objValue, srcValue, key, object, source, stack) => {
      if (this.isArray(objValue)) {
        return srcValue;
      }
    };
    return _.mergeWith.apply(null, [...args, callback]);
  },
  merge: function () {
    let customer = arguments[arguments.length - 1];
    let args = Array.prototype.slice.call(arguments, 0);
    if (this.isFunction(customer)) {
      return _.mergeWith.apply(null, args);
    } else {
      return _.merge.apply(null, args);
    }
  },
  //类似jQuery.extend方法，可用于浅拷贝，深拷贝
  mix: function () {
    var options,
      name,
      src,
      copy,
      copyIsArray,
      clone,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length,
      deep = false;

    // Handle a deep copy situation
    if (typeof target === "boolean") {
      deep = target;
      // Skip the boolean and the target
      target = arguments[i] || {};
      i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object" && !this.isFunction(target)) {
      target = {};
    }
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      // Only deal with non-null/undefined values
      if ((options = arguments[i]) != null) {
        // Extend the base object
        for (name in options) {
          copy = options[name];
          // Prevent Object.prototype pollution
          // Prevent never-ending loop
          if (name === "__proto__" || target === copy) {
            continue;
          }
          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (this.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
            src = target[name];
            // Ensure proper type for the source value
            if (copyIsArray && !Array.isArray(src)) {
              clone = [];
            } else if (!copyIsArray && !this.isPlainObject(src)) {
              clone = {};
            } else {
              clone = src;
            }
            copyIsArray = false;
            // Never move original objects, clone them
            target[name] = this.mix(deep, clone, copy);

            // Don't bring in undefined values
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }
    // Return the modified object
    return target;
  },
  //获取元素某个计算后的css属性
  getCss: function (curEle, attr) {
    var val = null,
      reg = null;
    if ("getComputedStyle" in window) {
      val = window.getComputedStyle(curEle, null)[attr];
    } else {
      //ie6~8不支持上面属性
      //不兼容
      if (attr === "opacity") {
        val = curEle.currentStyle["filter"]; //'alpha(opacity=12,345)'
        reg = /^alphaopacity=(\d+(?:\.\d+)?)opacity=(\d+(?:\.\d+)?)$/i;
        val = reg.test(val) ? reg.exec(val)[1] / 100 : 1;
      } else {
        val = curEle.currentStyle[attr];
      }
    }
    return val;
  },
  getUploadFileInfo(str, index) {
    let files = $files;
    if (str) {
      let result = JSON.parse(str);
      if (this.type(result) == "array") {
        files = result;
      } else if (this.type(result) == "object") {
        files = [result];
      }
    }
    if (this.isDef(index)) {
      return files[index];
    }
    return files;
  },
  getParse() {
    //获取一个json字符串对象中的属性值
    let str = arguments[0];
    if (str) {
      let result = JSON.parse(str);
      if (this.isDef(result)) {
        for (let i = 1; i < arguments.length; i++) {
          result = result[arguments[i]];
        }
      }
      return result;
    }
    return str;
  },
  //获取cookie值
  getCookie: function (cookie_name) {
    return dsf.cookies.get(cookie_name);
  },
  setCookie: function (cookie_name, value) {
    dsf.cookies.set(cookie_name, value);
  },
  toPromise: function (fn, ...params) {
    return toPromise(fn, ...params);
  },
  getToken() {
    return dsf.session.get(dsf.config.setting_public_tokenkey) || "";
  },
  getDefaultHttpHeader() {
    return {
      client: dsf.global.$isMobile ? "mobile" : "pc",
      client_info: dsf.base64.encode(JSON.stringify(dsf.client.info)),
      ...this.getTokenHttpHeader()
    };
  },
  getTokenHttpHeader() {
    return {
      [dsf.config.setting_public_tokenkey]: this.getToken()
    };
  },
  /**
   * 图片转base64
   * @param img 图片对象/图片链接/图片Blob对象/图片File对象
   * @param options {Object}
   * @param options.width {Number} 转换后的图片宽
   * @param options.height {Number} 转换后的图片高
   * @param options.format {String} 转换后的图片格式，image/jpeg 或 image/png，默认image/png
   * @param options.encoderOptions {Number} 当为jpeg时，设置图片压缩率
   * @returns {Promise<never>|Promise<String>}
   */
  image2Base64(img, options = {}) {
    return import(/* webpackChunkName: "core_helper_async" */ "./~helper").then((res) => {
      return res.default.imgCompress(img, options, "base64");
    });
  },
  /**
   * 图片转blob
   * @param img 图片对象/图片链接/图片Blob对象/图片File对象
   * @param options {Object}
   * @param options.width {Number} 转换后的图片宽
   * @param options.height {Number} 转换后的图片高
   * @param options.format {String} 转换后的图片格式，image/jpeg 或 image/png，默认image/png
   * @param options.encoderOptions {Number} 当为jpeg时，设置图片压缩率
   * @returns {Promise<never>|Promise<String>}
   */
  image2Blob(img, options = {}) {
    return import(/* webpackChunkName: "core_helper_async" */ "./~helper").then((res) => {
      return res.default.imgCompress(img, options);
    });
  },
  /**
   * 生成二维码
   * @param options {Object | String} 字符串时同options.content
   * @param options.content {String} 要转换的文本内容
   * @param options.width {Number} 要生成图片的宽度，默认300
   * @param options.height {Number} 要生成图片的高度，默认300
   * @returns {Promise<never>|Promise<string>}
   */
  qrCode(options = "") {
    return import(/* webpackChunkName: "core_helper_async" */ "./~helper").then((res) => {
      return res.default.qrCode(options);
    });
  },
  removePoint(data) {
    // 循环递归 去掉"."
    const copyData = JSON.parse(JSON.stringify(data));
    let endObj = null;
    if (this.type(copyData) === "object") {
      endObj = {};
      for (let [key, value] of Object.entries(copyData)) {
        // console.log(`key: ${key} value:${value}`);
        const arr = key.split(".");
        const newKey = arr[arr.length - 1];
        if (this.type(value) === "object" || this.type(value) === "array") {
          endObj[newKey] = this.removePoint(value);
        } else {
          endObj[newKey] = value;
        }
      }
    } else if (this.type(copyData) === "array") {
      endObj = [];
      copyData.forEach((item, index) => {
        if (this.type(item) === "object") {
          endObj[index] = {};
          for (let [key, value] of Object.entries(item)) {
            // console.log(`key: ${key} value:${value}`);
            const arr = key.split(".");
            const newKey = arr[arr.length - 1];
            let newValue;
            if (this.type(value) === "object") {
              newValue = this.removePoint(value);
            } else if (this.type(value) === "array") {
              newValue = this.removePoint(value);
            } else {
              newValue = value;
            }
            endObj[index][newKey] = newValue;
          }
        }
      });
    } else {
      endObj = data;
    }
    return endObj;
  },
  /**
   * 往上查找离el最近的带滚动条的容器
   * @param el {HTMLElement}
   * @returns {HTMLElement}
   */
  findScrollEl(el) {
    while (el.parentElement) {
      el = el.parentElement;
      if (el.tagName === "HTML") {
        break;
      }
      let computedStyle = window.getComputedStyle(el);
      let overflowX = el.style.getPropertyValue("overflow-x") || computedStyle["overflow-x"];
      let overflowY = el.style.getPropertyValue("overflow-y") || computedStyle["overflow-y"];
      let overflow = el.style.getPropertyValue("overflow") || computedStyle["overflow"];
      if (
        overflowY === "auto" ||
        overflow === "auto" ||
        overflowX === "auto" ||
        overflowY === "scroll" ||
        overflow === "scroll" ||
        overflowX === "scroll"
      ) {
        break;
      }
    }
    return el;
  },
  /**
   * 递归遍历
   * @param obj       要遍历的对象或数组
   * @param callback  回调函数，Function(item, level: 层级, index: 所在层级的索引, parent: 父级)。
   *                  返回1则跳过当前层的遍历；
   *                  返回0则结束当前层的遍历，且继续该层的子层级遍历；
   *                  返回-1则结束当前层的遍历。
   * @param options
   * @param options.children  子层级的字段名
   * @param options.isLast    是否只遍历最后一层
   */
  deepForEach(obj, callback, options) {
    if (!callback) return;
    let { children = "children", isLast = false } = options || {};
    deepForEach(null, obj, 0, 0, callback, {
      children,
      isLast
    });
  },
  codeExec(str) {
    let code = [`return (${str})`];
    let fn = new Function(code.join("\r\n"));
    let result = fn();
    return result;
  },
  /**
   * 克隆
   * @param obj 要克隆的对象或数组
   * @param fn 克隆每一项时的处理函数，返回值为对象，则作为要克隆该项的数据，返之则跳过此项的克隆。
   * @param opt 额外参数
   * @param opt.children 默认为children
   * @returns {*[]|*}
   */
  cloneDeepWith(obj, fn, opt = { children: "children" }) {
    return cloneDeepWith(obj, fn, opt);
  },
  /**
   * 手动触发窗口的resize事件
   */
  dispatchResize() {
    let evt;
    if (window.Event) {
      evt = new Event("resize", {
        bubbles: false,
        cancelable: false
      });
    } else {
      evt = document.createEvent("HTMLEvents");
      evt.initEvent("resize", false, false);
    }
    window.dispatchEvent(evt);
  },
  /**
   * 可用于字符串脱敏
   *  例如：dsf.subReplace('12345678910', 3, 4, '*') 输出 '123****8910'
   * @param str
   * @param start 起始保留字符
   * @param end   末尾保留字符
   * @param code  要替换的字符
   * @returns {string|*}
   */
  subReplace(str, start, end, code = "*") {
    if (!str || !dsf.isNumber(start) || !dsf.isNumber(end)) return "";
    let l = str.length;
    let c = l - start - end;
    if (c <= 0) return repeatByCode(l, code);
    let r = new RegExp(`(.{${start}}).{${c}}(.{${end}})`);
    return str.replace(r, `$1${repeatByCode(c, code)}$2`);
  },
  /**
   * 对比文字x与文字y，返回相似度
   * @param x
   * @param y
   * @returns {number}
   */
  stringSimilar(x, y) {
    var z = 0;
    x = x.toUpperCase();
    y = y.toUpperCase();
    x = x.replace("_", "");
    y = y.replace("_", "");
    if (typeof x == "string") {
      x = x.split("");
      y = y.split("");
    }
    var s = x.length + y.length;
    x.sort();
    y.sort();
    var a = x.shift();
    var b = y.shift();
    while (a !== undefined && b != undefined) {
      if (a === b) {
        z++;
        a = x.shift();
        b = y.shift();
      } else if (a < b) {
        a = x.shift();
      } else if (a > b) {
        b = y.shift();
      }
    }
    return (z / s) * 200;
  },
  /**
   * 为obj赋上一个值为value且不可被枚举的属性attr
   * @param obj {{}}
   * @param attr {string}
   * @param value {*}
   * @returns {{}}
   */
  setObjAttr(obj, attr, value) {
    Object.defineProperty(obj, attr, {
      configurable: true,
      writable: true,
      value: value
    });
    return obj;
  },
  /**
   * 为obj赋上一堆值不可被枚举的属性attrs
   * @param obj {{}}
   * @param attrs {{}}
   * @returns {{}}
   */
  setObjAttrs(obj, attrs) {
    _.each(attrs, (v, k) => dsf.setObjAttr(obj, k, v));
    return obj;
  },
  /**
   * @description: 对象转字符串
   * 解决JSON.stringify不能序列化以下数据类型问题
   * ====  bigint
   * ====  undefined/Infinity/NaN
   * ====  Set
   * ====  Map
   * ====  Date
   * ====  function
   * ====  RegExp
   * ====  循环引用
   * @param {*} obj  json对象
   * @result: json字符串
   */

  unEval(obj) {
    let cycleData = new Map(); // 记录uneval循环引用数据
    const getCycleData = (data) => {
      const type = Object.prototype.toString.apply(data);
      const vaildType = ["[object Object]", "[object Array]", "[object Map]", "[object Set]"];
      switch (type) {
      case "[object Object]":
        if (cycleData.get(data)) {
          cycleData.set(data, 2);
          return;
        } else {
          cycleData.set(data, 1);
          Object.values(data).forEach((item) => {
            const itemType = Object.prototype.toString.apply(item);
            if (vaildType.includes(itemType)) {
              getCycleData(item);
            }
          });
        }
        break;
      case "[object Array]":
        if (cycleData.get(data)) {
          cycleData.set(data, 2);
          return;
        } else {
          cycleData.set(data, 1);
          data.forEach((item) => {
            const itemType = Object.prototype.toString.apply(item);
            if (vaildType.includes(itemType)) {
              getCycleData(item);
            }
          });
        }
        break;
      case "[object Map]":
      case "[object Set]":
        Array.from(data).forEach(getCycleData);
        break;
      default:
        return;
      }
    };
    getCycleData(obj);
    // 删除引用数为1的对象
    let varName = 0;
    cycleData.forEach((value, key, index) => {
      if (value === 1) {
        cycleData.delete(key);
      } else {
        cycleData.set(key, `_${varName}`);
        varName++;
      }
    });
    // 获取解析结果
    const result = unEval(obj, cycleData);
    if (cycleData.size) {
      // 序列化引用对象
      let functionStr = ``;
      let varNameType = [];
      let jsonStr = "";
      cycleData.forEach((varName, key) => {
        const data = Object.prototype.toString.apply(key) === "[object Object]" ? "{}" : "[]";
        varNameType.push([varName, data]);
        const type = Object.prototype.toString.apply(key);
        if (type === "[object Object]") {
          Object.entries(key).forEach(([objKey, objValue]) => {
            jsonStr += `${varName}.${objKey} = ${unEval(objValue, cycleData)};`;
          });
        } else {
          key.forEach((item, index) => {
            jsonStr += `${varName}[${index}] = ${unEval(item, cycleData)};`;
          });
        }
      });
      functionStr = `(function serialize(${varNameType
        .map((item) => item[0])
        .join(",")}) {${jsonStr} return ${result}})(${varNameType
          .map((item) => item[1])
          .join(",")})`;
      return functionStr;
    } else {
      return result;
    }
  },
  eval(str) {
    if (dsf.isString(str)) {
      return eval(`(${str})`);
    }
    return str;
  },
  clearLoginInfo(cutomeClear) {
    dsf.session.remove(dsf.config.setting_public_tokenkey);
    dsf.storage.session.remove(dsf.config.setting_public_tokenkey);
    dsf.storage.local.remove(dsf.config.setting_public_tokenkey);
    dsf.session.remove("a");
    dsf.session.remove("isLogin");
    dsf.session.remove("license_expire_warn_key"); //许可证过期倒计时
    dsf.storage.session.clear();
    cutomeClear && cutomeClear();
  },
  loginOut(url, cutomeClear) {
    let api = dsf.api.getAPI();
    if (!url) {
      url = dsf.config.setting_public_pc_login_page;
      if (dsf.global.$isMobile) {
        url = dsf.url.getMobileLogin();
      }
    }
    let topWin = dsf.getTopWindow();
    let root = topWin.__multiPageVm__ ? topWin : window;
    api
      .loginOut()
      .then((res) => {
        dsf.clearLoginInfo(cutomeClear);
        //如果接口返回指定跳转路径以接口为准
        if (res && res.data && res.data.outUrl) {
          root.location.replace(res.data.outUrl);
        } else {
          root.location.replace(url);
        }
      })
      .catch(() => {
        dsf.clearLoginInfo(cutomeClear);
        root.location.replace(url);
      });
  },
  /**
   * 创建dsf使用的vue.use可调用的包
   * @param {*} libName
   * @param {*} controls
   * @returns
   */
  createDsfVueInstall(libName, controls) {
    return function (Vue) {
      for (const key in controls) {
        const it = controls[key];
        const name = dsf.isFunction(it) ? it.ctrlName || key : it.name;
        Vue.component(name, it);
        if (!window.$components[libName]) {
          window.$components[libName] = {};
        }
        window.$components[libName][name] = it;
      }
      libName = null;
      controls = null;
    };
  },
  /**
   * 将正则表达式字符串转义成普通字符串
   * @example
   *    new RegExp('(' + '高(新）产业' + ')')
   *      // 报错
   *    new RegExp('(' + dsf.escapeForRegExp('高(新）产业') + ')')
   *      // 输出： /(高\(新）产业)/
   * @param str
   * @returns {*}
   */
  escapeForRegExp(str) {
    return dsf.isString(str) ? str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : str;
  }
};

function repeatByCode(length, code) {
  let l = code.length;
  let n = Math.ceil(length / l);
  let r = _.repeat(code, n);
  return r.substr(0, length);
}
function toPromise(fn, ...params) {
  return new Promise((resolve, reject) => {
    let next = (mark) => {
      if (mark === false || mark instanceof Error) {
        reject(mark);
      } else {
        resolve(true);
      }
    };
    if (fn) {
      fn(next, ...params);
    } else {
      next();
    }
  });
}
/**
 * 递归遍历
 * @param parentObj
 * @param obj
 * @param level
 * @param index
 * @param callback
 * @param children
 * @param isLast
 * @returns {any}
 */
function deepForEach(
  parentObj,
  obj,
  level = 0,
  index = 0,
  callback,
  { children = "children", isLast = false }
) {
  if (Array.isArray(obj)) {
    if (!children) {
      for (let i = 0; i < obj.length; i++) {
        let res = callback(obj[i], 0, i, null);
        if (res === -1) return -1;
        if (res === 0) break;
      }
    } else {
      for (let i = 0; i < obj.length; i++) {
        let res = deepForEach(parentObj, obj[i], level, i, callback, {
          children,
          isLast
        });
        if (res === -1) return -1;
        if (res === 0) break;
      }
    }
  } else if (typeof obj == "object") {
    let child = dsf.isFunction(children) ? children(obj) : obj[children],
      res = undefined;
    if (!isLast || !child || !child.length) {
      res = callback(obj, level, index, parentObj);
    }
    if (((dsf.isArray(child) && child.length) || dsf.isObject(child)) && !res) {
      return deepForEach(obj, child, level + 1, 0, callback, {
        children,
        isLast
      });
    }
    return res;
  }
}

/**
 * @description: 对象转字符串
 * 解决JSON.stringify不能序列化以下数据类型问题
 * ====  bigint
 * ====  undefined/Infinity/NaN
 * ====  Set
 * ====  Map
 * ====  Date
 * ====  function
 * ====  RegExp
 * ====  循环引用
 * @param {Object|Array} obj  json对象
 * @param {Map} cycleData  循环引用对象集合
 * @result: json字符串
 */
function unEval(obj, cycleData) {
  const type = typeof obj;
  if (type !== "object") {
    switch (type) {
    case "number":
      if (Number.isNaN(obj)) {
        return "NaN";
      } else if (obj === Infinity) {
        return "Infinity";
      } else {
        return obj === 0 && 1 / obj < 0 ? `-${obj}` : `${obj}`;
      }
    case "function":
      return obj.toString();
    case "undefined":
      return "undefined";
    case "symbol":
      console.error(
        "注意！【dsf.unEval】虽然能序列化Symbol类型,但是反序列化后该值也和原对象的Symbol值不等。"
      );
      const description = /Symbol\((.*)\)$/.exec(obj.toString())[1];
      let symbolStr = "";
      if (!isNaN(Number(description)) || description === "true" || description === "false") {
        symbolStr = `${obj.toString()}`;
      } else {
        symbolStr = `Symbol("${description}")`;
      }
      return symbolStr;
    case "bigint":
      return obj + "n";
    default:
      return `"${obj}"`;
    }
  } else {
    const definedType = Object.prototype.toString.apply(obj);
    switch (definedType) {
    case "[object RegExp]":
      return obj.toString();
    case "[object Null]":
      return null;
    case "[object Date]":
      return `new Date(${obj.getTime()})`;
    case "[object Array]":
      const value = cycleData.get(obj);
      if (value) {
        return value;
      } else {
        let jsonStr = [];
        obj.forEach((item, index) => {
          jsonStr[index] = unEval(item, cycleData);
        });

        jsonStr = `[${jsonStr.toString()}]`;
        return jsonStr.replace(/'/g, '"');
      }

    case "[object Object]":
      const value1 = cycleData.get(obj);
      if (value1) {
        return value1;
      } else {
        let jsonStr1 = [];
        Object.entries(obj).forEach(([key, value]) => {
          jsonStr1.push(`"${key}":${unEval(value, cycleData)}`);
        });
        return `{${jsonStr1.toString()}}`;
      }
    case "[object Set]":
      return `new Set([${Array.from(obj)
        .map((value) => unEval(value, cycleData))
        .join(",")}])`;
    case "[object Map]":
      return `new Map([${Array.from(obj)
        .map((value) => unEval(value, cycleData))
        .join(",")}])`;
    }
  }
}

function debugConsoleProxy(fnName, args) {
  if (window.dsfDebug) {
    return;
  }
  const method = _console[fnName] || _console.log;
  Function.apply.call(method, _console, args);
}
function consoleProxy(fnName, args) {
  if (hasConsole) {
    return;
  }
  const method = _console[fnName] || _console.log;
  Function.apply.call(method, _console, args);
}

function cloneDeepWith(obj, fn, opt = { children: "children" }, parent = null, level = 0) {
  if (!fn) return _.cloneDeep(obj);
  if (dsf.isArray(obj)) {
    let arr = [];
    _.each(obj, (o, i) => {
      let item = fn(o, parent, level, i, arr);
      if (dsf.isObject(item)) {
        if (o[opt.children]?.length) {
          item[opt.children] = cloneDeepWith(o[opt.children], fn, opt, o, level + 1);
        }
        arr.push(item);
      }
    });
    return arr;
  }
  let item = fn(obj, parent, level, 0);
  if (dsf.isObject(item)) {
    if (obj[opt.children]?.length) {
      item[opt.children] = cloneDeepWith(obj[opt.children], fn, opt, obj, level + 1);
    }
    return item;
  }
}
